import { requestGet } from '@/utils/request';

const api = {
	LIST: '/op/user_bet_list',
};

export async function userBetList(queryParams) {
	return requestGet(api.LIST, queryParams);
}
